"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languageResourceList = exports.languageOptions = void 0;

var _enCA = _interopRequireDefault(require("./en-CA"));

var _enUS = _interopRequireDefault(require("./en-US"));

var _frCA = _interopRequireDefault(require("./fr-CA"));

var languageResourceList = {
  enCA: _enCA["default"],
  enUS: _enUS["default"],
  frCA: _frCA["default"]
};
exports.languageResourceList = languageResourceList;
var languageOptions = {
  enCA: 'English CA',
  enUS: 'English US',
  frCA: 'Français Canadien'
};
exports.languageOptions = languageOptions;